// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2damr","col":"styles_col__3mgO2","actions":"styles_actions__1Rkin","conflict":"styles_conflict__25wQw"};